import React, { Component } from 'react';
import Routes from './Routes';
import './App.css';

const footerStyle = {
  backgroundColor: 'white',
  fontSize: '11px',
  color: 'white',
  textAlign: 'center',
  position: 'fixed',
  left: '0',
  bottom: '0',
  width: '100%',
  height: '3%',
};

const phantomStyle = {
  display: 'block',
  padding: '30%',
  height: '100%',
  position: 'fixed',
  width: '100%',
};

function LocalFooter({ children }) {
  return (
    <div>
      <div style={phantomStyle} />
      <div style={footerStyle}>{children}</div>
    </div>
  );
}

function Footer() {
  return (
    <span className="footer-text">
      Brought to you by{' '}
      <a
        className="link-style"
        href="https://zengo.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        ZenGo
      </a>
      . For more details, visit our{' '}
      <a
        className="link-style"
        href="https://zengo.com/baDAPProve"
        target="_blank"
        rel="noopener noreferrer"
      >
        blog
      </a>
      /
      <a
        className="link-style"
        href="https://github.com/KZen-networks/compound-playground"
        target="_blank"
        rel="noopener noreferrer"
      >
        github
      </a>{' '}
    </span>
  );
}

class App extends Component {
  render() {
    return (
      <div>
        <Routes />
        <LocalFooter>
          <Footer />
        </LocalFooter>
      </div>
    );
  }
}
export default App;
